import React, { Component } from 'react';
import './index.css';

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e,key){
    this.props.onClick(e,key);
  }

  render() {
    const { lang, pagination, numberOfArticlesInPage, blogeContent } = this.props;
    const isThereNext = numberOfArticlesInPage + (numberOfArticlesInPage*pagination) < blogeContent.length;
    const isTherePrev = numberOfArticlesInPage*(pagination - 1) >= 0;
    return (
      <div className='blog-sbc-component-pagination-container'>
        <div className='blog-sbc-component-pagination-wrapper'>
          {isTherePrev && <button onClick={(e)=>this.clickHandler(e,'prev')} 
            className='transparent-black-opacity-button custom-button'>{lang==='fa'? 'قبلی': 'prev'}</button>
          }
          {isThereNext && <button onClick={(e)=>this.clickHandler(e,'next')}
            className='transparent-black-opacity-button custom-button'>{lang==='fa'? 'بعدی': 'next'}</button>
          }
        </div>
      </div>
    )
  }
}

export default Pagination;
